module.exports = __webpack_public_path__ + "src/routes/help/basic.jpg?a27f4295";


//////////////////
// WEBPACK FOOTER
// ./src/routes/help/basic.jpg
// module id = 2844
// module chunks = 1